export const useBannerApi = () => useApi<Banner[]>('/banners')
export const useBannerByIdApi = (id: string) => useApi<Banner>(`/banners/${id}`)
